export class Grupo {
	constructor(
		public uuid: string,
		public nombre: string,
		public proyecto: string,
	) {}
}